module.exports = __webpack_public_path__ + "img/home_desc.e2dde587.png";